import React from 'react';
import Logger from '../configs/logger.configs';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hasError: false,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorInfo: error,
    };
  }

  componentDidCatch(error, errorInfo) {
    const isChunkLoadError =
      error?.name === 'ChunkLoadError' ||
      error?.message?.includes('Loading chunk') ||
      error?.message?.includes('Failed to fetch dynamically imported module');

    Logger(`${window.location.href} - ${error.toString()}`);
    Logger(`ErrorInfo: ${JSON.stringify(errorInfo)}`);

    if (isChunkLoadError) {
      const reloadKey = 'chunk-reload-attempted';

      if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, 'true');

        Logger(`${window.location.href} - ChunkLoadError detected. Auto reloading page.`);

        window.location.reload();

        return;
      }

      Logger(`${window.location.href} - ChunkLoadError still exists after reload.`);
    }
  }

  componentDidMount() {
    sessionStorage.removeItem('chunk-reload-attempted');
  }

  goBack = () => {
    window.history.go(-1);

    setTimeout(() => {
      window.location.reload();
    }, 200);
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="app-error">
          <div className="orange-text">
            <span className="material-icons vertical-align-middle">report</span> OOP!
          </div>

          <div className="red-text">Something went wrong!</div>

          <div className="red-text">
            <span className="cursor-pointer" onClick={this.goBack}>
              <span className="material-icons vertical-align-middle">arrow_back</span>
            </span>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
